import a2 from "./images/2a.jpg";
import a3 from "./images/3a.jpg";
import a6 from "./images/6.jpg";
import a7 from "./images/7a.jpg";
import a9 from "./images/9a.jpg";
import a11 from "./images/11a.jpg";
import a12 from "./images/12.jpg";
import a14 from "./images/14a.jpg";
import a16 from "./images/16a.jpg";
import a20 from "./images/20a.jpg";
import a22 from "./images/22.jpg";
import a23 from "./images/23a.jpg";
import a24 from "./images/24a.jpg";
import a36 from "./images/36a.jpg";
import a27 from "./images/27a.jpg";
import a33 from "./images/33a.jpg";
import a38 from "./images/38a.jpg";
import a44 from "./images/44a.jpg";
import a46 from "./images/46a.jpg";
import a61 from "./images/61.jpg";
import a64 from "./images/64.jpg";
import a73 from "./images/73.jpg";
import a23a from "./images/23a_1.jpg";
import a36a from "./images/36a_1.jpg";
import a10a from "./images/10a.jpg";
import a18a from "./images/18a.jpg";
import a22a from "./images/22a.jpg";
import a24a from "./images/24a_1.jpg";
import a32 from "./images/32a.jpg";
import a33_1 from "./images/33a_1.jpg";
import a36_2 from "./images/36a_2.jpg";
import a41 from "./images/41a.jpg";
import a43a from "./images/43a.jpg";
import a45a from "./images/45a.jpg";
import a47a from "./images/47a.jpg";
import a51a from "./images/51a.jpg";
import a51a_1 from "./images/51a1.jpg";
import a8 from "./images/8a.jpg";

import a2_big from "./res/2a.jpg";
import a3_big from "./res/3a.jpg";
import a6_big from "./res/6.jpg";
import a7_big from "./res/7a.jpg";
import a9_big from "./res/9a.jpg";
import a11_big from "./res/11a.jpg";
import a12_big from "./res/12.jpg";
import a14_big from "./res/14a.jpg";
import a16_big from "./res/16a.jpg";
import a20_big from "./res/20a.jpg";
import a22_big from "./res/22.jpg";
import a23_big from "./res/23a.jpg";
import a24_big from "./res/24a.jpg";
import a36_big from "./res/36a.jpg";
import a27_big from "./res/27a.jpg";
import a33_big from "./res/33a.jpg";
import a38_big from "./res/38a.jpg";
import a44_big from "./res/44a.jpg";
import a46_big from "./res/46a.jpg";
import a61_big from "./res/61.jpg";
import a64_big from "./res/64.jpg";
import a73_big from "./res/73.jpg";
import a23a_big from "./res/23a_1.jpg";
import a36a_big from "./res/36a_1.jpg";
import a10a_big from "./res/10a.jpg";
import a18a_big from "./res/18a.jpg";
import a22a_big from "./res/22a.jpg";
import a24a_big from "./res/24a_1.jpg";
import a32_big from "./res/32a.jpg";
import a33_1_big from "./res/33a_1.jpg";
import a36_2_big from "./res/36a_2.jpg";
import a41_big from "./res/41a.jpg";
import a43a_big from "./res/43a.jpg";
import a45a_big from "./res/45a.jpg";
import a47a_big from "./res/47a.jpg";
import a51a_big from "./res/51a.jpg";
import a51a_1_big from "./res/51a1.jpg";
import a8_big from "./res/8a.jpg";

export const portfolio = {
  tasks: [
    { id: 1, title: "title", photo: a2, photoBig: a2_big, tags: ["Индивидуальная"], size: 'large',},
    { id: 2, title: "title", photo: a3, photoBig: a3_big, tags: ["Индивидуальная"], size: 'medium',},
    { id: 3, title: "title", photo: a6, photoBig: a6_big, tags: ["Животные"], size: 'medium',  },
    { id: 4, title: "title", photo: a7, photoBig: a7_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 5, title: "title", photo: a9, photoBig: a9_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 6, title: "title", photo: a11, photoBig: a11_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 7, title: "title", photo: a12, photoBig: a12_big, tags: ["Животные"], size: 'medium',  },
    { id: 8, title: "title", photo: a14, photoBig: a14_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 9, title: "title", photo: a16, photoBig: a16_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 10, title: "title", photo: a20, photoBig: a20_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 11, title: "title", photo: a22, photoBig: a22_big, tags: ["Животные"], size: 'medium',  },
    { id: 12, title: "title", photo: a23, photoBig: a23_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 13, title: "title", photo: a24, photoBig: a24_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 14, title: "title", photo: a27, photoBig: a27_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 15, title: "title", photo: a33, photoBig: a33_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 16, title: "title", photo: a36, photoBig: a36_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 17, title: "title", photo: a38, photoBig: a38_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 18, title: "title", photo: a44, photoBig: a44_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 19, title: "title", photo: a46, photoBig: a46_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 20, title: "title", photo: a61, photoBig: a61_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 21, title: "title", photo: a64, photoBig: a64_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 22, title: "title", photo: a73, photoBig: a73_big, tags: ["Семейная"], size: 'large',  },
    { id: 23, title: "title", photo: a23a, photoBig: a23a_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 24, title: "title", photo: a36a, photoBig: a36a_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 25, title: "title", photo: a10a, photoBig: a10a_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 26, title: "title", photo: a18a, photoBig: a18a_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 27, title: "title", photo: a22a, photoBig: a22a_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 28, title: "title", photo: a24a, photoBig: a24a_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 29, title: "title", photo: a32, photoBig: a32_big, tags: ["Семейная"], size: 'medium',  },
    { id: 30, title: "title", photo: a33_1, photoBig: a33_1_big, tags: ["Семейная"], size: 'medium',  },
    { id: 31, title: "title", photo: a36_2, photoBig: a36_2_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 32, title: "title", photo: a41, photoBig: a41_big, tags: ["Семейная"], size: 'large',  },
    { id: 33, title: "title", photo: a43a, photoBig: a43a_big, tags: ["Индивидуальная"], size: 'medium',  },
    { id: 34, title: "title", photo: a45a, photoBig: a45a_big, tags: ["Индивидуальная"], size: 'large',  },
    { id: 35, title: "title", photo: a47a, photoBig: a47a_big, tags: ["Семейная"], size: 'medium',  },
    { id: 36, title: "title", photo: a51a, photoBig: a51a_big, tags: ["Семейная"], size: 'large',  },
    { id: 37, title: "title", photo: a51a_1, photoBig: a51a_1_big, tags: ["Семейная"], size: 'medium',  },
    { id: 38, title: "title", photo: a8, photoBig: a8_big, tags: ["Индивидуальная"], size: 'medium',  },
  ],
};
